import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { SOLICITUD_ALTERNATIVAS_API } from '../../../shared/services/solicitudAlternativas';
import ActionButton from '../ActionButton';
import ActionCommentField from '../ActionCommentField';
import InfoField from '../InfoField';
import { ModalPanel } from '../layout/ModalSection';

const NotaInternaModal = ({ currentItem, onClose }) => {
    const presupuestoOrigen = currentItem?.origen?.numero;
    const clienteNombre = currentItem?.origen?.entidad?.nombre;
    const [nota, setNota] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = useCallback(async () => {
        const trimmed = nota.trim();
        if (!trimmed) {
            toast.error('Escribe el contenido de la nota.');
            return;
        }

        setSubmitting(true);
        try {
            const res = await SOLICITUD_ALTERNATIVAS_API.ejecutarAccionAtCliente({
                solicitud_id: currentItem.id,
                accion: 'add_note',
                comentario: trimmed,
            });

            if (!res?.success) {
                toast.error(res?.message || 'Ha ocurrido un error.');
                return;
            }

            toast.success('Nota interna añadida.');
            onClose();
        } catch (e) {
            toast.error(
                e?.response?.data?.message ||
                    e?.message ||
                    'Ha ocurrido un error.',
            );
        } finally {
            setSubmitting(false);
        }
    }, [currentItem.id, nota, onClose]);

    return (
        <div>
            <ModalPanel className="card p-3 mb-4">
                <div className="row g-3">
                    <div className="col-6">
                        <InfoField
                            label="ID Solicitud"
                            value={currentItem?.id ?? '-'}
                        />
                    </div>
                    <div className="col-6">
                        <InfoField
                            label="Presupuesto origen"
                            value={presupuestoOrigen || '-'}
                        />
                    </div>
                    {clienteNombre ? (
                        <div className="col-12">
                            <InfoField
                                label="Cliente"
                                value={clienteNombre}
                            />
                        </div>
                    ) : null}
                </div>
            </ModalPanel>

            <ActionCommentField
                label="Nota interna"
                placeholder="Escribe la nota interna..."
                value={nota}
                onChange={(e) => setNota(e.target.value)}
                required
            />
            <div className="d-flex justify-content-end mt-4">
                <ActionButton
                    disabled={submitting || !nota.trim()}
                    loading={submitting}
                    label="Guardar nota"
                    onClick={handleSubmit}
                />
            </div>
        </div>
    );
};

export default NotaInternaModal;
